import AdvanteIcons from "../AdvanteIcons"; 


const Header = () => {
    return (
        <section className='platform-header' >
        
            <div className="containerFull">
                <div className="platform-header-wrapper">
                    <div className="platform-header-copy">
                        <div className="platform-header-icon">
                            <AdvanteIcons 
                                type="IcoPlatformIntegrations" 
                                fill="var(--heart-purple)"
                            />
                        </div>
                        <h2>Platform Integrations.</h2>
                        <p>We connect and maintain the APIs, portals, dashboards, payment flows, and internal tools your existing platforms depend on. We improve real systems using AI-assisted engineering with human review, and protect production with staging, QA, pull requests, and controlled deployment.</p>
                    </div>
              
                </div>
                
            </div>
        </section>
    );
  }
  
  export default Header;